import React from 'react';
import './passwordRecoveryForm.css'

const PasswordRecoveryForm = ({ formState, handleChange, handleSubmit, error, handleBack }) => (
  <form className="password-recovery__form" onSubmit={handleSubmit}>
    <h2>Recupera tu contraseña</h2>
    <div className="password-recovery__input-container">
      <label>Email</label>
      <input
        type="email"
        name="email"
        placeholder="Email"
        value={formState.email}
        onChange={handleChange}
        className='password-recovery-form__input'
      />
    </div>
    <div className="password-recovery__buttons-container">
      <button 
        type="submit" 
        className="password-recovery__button"
      >
        Enviar
      </button>
      <button 
        onClick={handleBack} 
        className="password-recovery__back-button"
      >
        Volver
      </button>
    </div>
    {error && <p className="error-message">{error}</p>}
  </form>
);

export default PasswordRecoveryForm;
